/**
 * 	PRODUCT PAGE
 * 		LIGHT SLIDER
 */
const moduleLS = {};

moduleLS.sliders = [];

moduleLS.init = () => {

  moduleLS.sliders = cube.$class('lightslider');

  const reInitSlider = sliderParam => {
    const slider = sliderParam;
    slider.hasArrowNav = !!(slider.$tag('nav').length);

    return () => {
      const sliderItems = slider.$$('.pictures > *');
      slider.totalWidth = 0;
      [...sliderItems].forEach(sliderItem => {
        slider.totalWidth += sliderItem.offsetWidth;
      });
      if ((slider.offsetWidth < slider.totalWidth) && (!slider.hasArrowNav))
        moduleLS.buildArrowNav(slider);
      else if ((slider.offsetWidth >= slider.totalWidth) && (slider.hasArrowNav))
        moduleLS.destroyArrowNav(slider);
    };
  };

  // Init Each Sliders : On img.load > reInitSlider
  [...moduleLS.sliders].forEach(slider => {
    const $imgHolders = slider.$tag('picture');
    const sliderReInit = reInitSlider(slider);
    const listenLoad = img => {
      img.addEventListener('load', sliderReInit);
    };
    const listenMutation = picture => {
      const mutationCallback = () => {
        if (picture.$('img')) {
          listenLoad(picture.$('img'));
          observer.disconnect();
        }
      };
      const observerConfig = { childList: true };
      const observer = new MutationObserver(mutationCallback);

      observer.observe(picture, observerConfig);
    };

    [...$imgHolders].forEach(imgHolder => {
      if (imgHolder.$('img')) listenLoad(imgHolder.$('img'));
      else listenMutation(imgHolder);
    });

    cube.event.on('resize-width', cube.debounce(sliderReInit, 75));
    sliderReInit();
  });
};

moduleLS.buildArrowNav = slider => {
  const pictures = slider.$('.pictures');
  const images = slider.$$('img');
  const nav = document.createElement('nav');
  const dsblClass = 'disabled';
  let leftBtn;
  let rightBtn;
  const clickDirection = e => {

    // Elements
    const direction = e.target.dataset.direction;
    const isDisabled = (e.target.className === dsblClass);
    // Scroll info
    const picturesScrollCurrent = pictures.scrollLeft;
    let picturesDelta = 0;
    let i = 0;
    // Count the necessary delta
    if (direction === 'left') {
      while (picturesDelta < picturesScrollCurrent) {
        picturesDelta += images[i].width; i += 1;
      }
      if (i > 0) picturesDelta -= images[i-1].width;
    } else {
      while (picturesDelta <= picturesScrollCurrent) {
        picturesDelta += images[i].width; i += 1;
      }
    }
    if (!isDisabled)
      $(pictures).animate({ scrollLeft: picturesDelta }, 150);
  };
  const listenScroll = () => {
    const HighLimit = slider.totalWidth - slider.offsetWidth - 1;
    if (pictures.scrollLeft <= 0)
      leftBtn.classList.add(dsblClass);
    else
      leftBtn.classList.remove(dsblClass);

    if (pictures.scrollLeft >= HighLimit)
      rightBtn.classList.add(dsblClass);
    else
      rightBtn.classList.remove(dsblClass);
  };

  /* Nav Construction */
  nav.innerHTML =
    `<button data-direction="left"><span class="vh">prev</span></button>
    <button data-direction="right"><span class="vh">next</span></button>`;
  slider.appendChild(nav);
  slider.hasArrowNav = true;
  slider.classList.add('has-arrow-nav');
  leftBtn = slider.$('[data-direction="left"]');
  rightBtn = slider.$('[data-direction="right"]');
  /* Nav btn bindings */
  const linksDirection = slider.querySelectorAll('[data-direction]');
  [...linksDirection].forEach(linkDirection => {
    linkDirection.addEventListener('click', clickDirection);
  });
  /* Scroll listen for inactive state btns handling */
  $(pictures).on('scroll.lightSlider', cube.debounce(listenScroll, 75));
  listenScroll();
};

moduleLS.destroyArrowNav = slider => {
  const nav = slider.$('nav');
  const pictures = slider.$('.pictures');
  slider.removeChild(nav);
  slider.hasArrowNav = false;
  slider.classList.remove('has-arrow-nav');
  $(pictures).off('scroll.lightSlider');
};

module.exports = moduleLS;



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-light-slider.js